const MAIN_SCROLL_SELECTOR = "[data-app-main-scroll]";

/**
 * Lock the app main scroll pane while overlays are open.
 * Only touches the Layout scroll container — MUI Dialog handles body scroll lock.
 * Uses overflowY (not overflow shorthand) so React's Layout styles are restored correctly.
 * @returns {() => void} cleanup
 */
export function lockAppScroll() {
  const scrollEl = document.querySelector(MAIN_SCROLL_SELECTOR);
  if (!scrollEl) {
    return () => {};
  }

  const prevOverflowY = scrollEl.style.overflowY;
  scrollEl.style.overflowY = "hidden";

  return () => {
    scrollEl.style.overflowY = prevOverflowY || "auto";
  };
}
